<template>
  <b-modal v-model="show" size="lg" title="Кадастр маълумотлари"
           no-close-on-backdrop no-close-on-esc hide-header-close
           hide-footer centered>
    <div class="container-fluid">
      <div class="row" v-if="data.buildingSectionTypes">
        <template>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t("realEstate.cadastreDetails.buildingSectionTypeValue")}}</div>
              <div class="col-6">
                <span v-if="isMultiStorey || isResidential">{{$t("realEstate.category.residential.label")}}</span>
                <span v-else>{{$t('realEstate.category.notorious.label')}}</span>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.province')}}</div>
              <div class="col-6">{{ data.viloyat ? data.viloyat : '' }}</div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.region')}}</div>
              <div class="col-6">{{ data.tuman ? data.tuman : '' }}</div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.mfyName')}}</div>
              <div class="col-6">{{ data.mfyName ? data.mfyName : '' }}</div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.streetName')}}</div>
              <div class="col-6">{{ data.streetName ? data.streetName : '' }}</div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.address')}}</div>
              <div class="col-6">
                {{data.manzil ? data.manzil : ''}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.cadastreNumber')}}</div>
              <div class="col-6">
                {{ data.cadastreNumber ? data.cadastreNumber : '' }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.owner')}}</div>
              <div class="col-6" v-if="data.ownerType === 'Physical'">
                {{ data.lastName ? data.lastName : '' }}
                {{ data.firstName ? data.firstName : '' }}
                {{ data.middleName ? data.middleName : '' }}
              </div>
              <div class="col-6" v-else-if="data.ownerType === 'Legal'">
                {{ data.fullName ? data.fullName : '' }}
              </div>
            </div>
          </div>

        </template>
        <template v-if="isMultiStorey">
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.totalUsableArea')}}</div>
              <div class="col-6">
                {{ data.totalUsableArea ? data.totalUsableArea : (data.buildingArea ? data.buildingArea :'')}}
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.floor')}}</div>
              <div class="col-6">{{ data.floor ? data.floor : '' }}</div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.floorNumber')}}</div>
              <div class="col-6">{{ data.floorNumber ? data.floorNumber : '' }}</div>
            </div>
          </div>
        </template>
        <template v-else-if="isResidential">
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.landArea')}}</div>
              <div class="col-6">
                {{ data.legalArea ? data.legalArea : ''}}
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.buildingArea')}}</div>
              <div class="col-6">{{ data.buildingArea ? data.buildingArea : '' }}
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.totalUsableArea')}}</div>
              <div class="col-6">
                {{ data.totalUsableArea ? data.totalUsableArea : '' }}
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.floorNumber')}}</div>
              <div class="col-6">{{ data.floorNumber ? data.floorNumber : '' }}</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.landArea')}}</div>
              <div class="col-6">
                {{ data.legalArea ? parseFloat(data.legalArea) : data.taxableLandArea ? parseFloat(data.taxableLandArea) : ''}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.buildingArea')}}</div>
              <div class="col-6">{{ data.buildingArea ? data.buildingArea : '' }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.totalUsableArea')}}</div>
              <div class="col-6">
                {{ data.totalUsableArea ? data.totalUsableArea : (data.landUsedArea ? data.landUsedArea : '') }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.floor')}}</div>
              <div class="col-6">{{ data.floor ? data.floor : '' }}</div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">{{$t('realEstate.cadastreDetails.floorNumber')}}</div>
              <div class="col-6">{{ data.floorNumber ? data.floorNumber : '' }}</div>
            </div>
          </div>
        </template>
        <div class="col-12 mt-5">
          <div class="row">
            <div class="col-6 pr-2" v-if="canRefreshData">
              <button class="all-btn btn-info float-right" @click="refreshData">{{$t('action.refresh')}}</button>
            </div>
            <div class="col-6 pl-2" :class="{'col-12 pr-0 d-flex justify-content-center': !canRefreshData}">
              <button class="all-btn add-btn" :disabled="processing" @click="acceptData">{{$t('realEstate.action.confirm')}}</button>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-center mt-3 text-muted">
              <i class="fa fa-info-circle fa-lg text-info mr-1"></i> {{$t('realEstate.cadastreDetails.infoText')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {validationMixin} from 'vuelidate';
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
export default {
  name: "CadastreDetailsModal",
  mixins: [validationMixin],
  components: {
    'b-modal': bModal,
  },
  directives: {
    'b-modal': bModalDirective
  },
  props: {
    processing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      data: {},
      canRefreshData: true
    }
  },
  validations() {
    return {}
  },
  computed: {
    isMultiStorey() {
      return this.data.buildingSectionTypes === 'ResidentialMultiStorey';
    },
    isResidential() {
      return this.data.buildingSectionTypes === 'ResidentialIndividual';
    }
  },
  methods: {
    acceptData() {
      this.show = false
      this.showClientModal()
      this.$emit("handle-accept", this.data)

      this.processing = false
      this.data = {}
      this.canRefreshData = true
    },
    refreshData() {
      this.show = false
      this.canRefreshData = false
      this.$emit("handle-refresh")
    },
    showClientModal() {
      this.$eventBus.$emit('showClientDataModal');
    }
  },
  created() {
    this.$eventBus.$on('showCadastreDetailsModal', (data) => {
      console.log("showCadastre = ", data)
      this.show = true;
      this.data = data
    })

    this.$eventBus.$on('closeCadastreDetailsModal', () => {
      this.show = false;
      this.showClientModal()
    })
  },
  beforeDestroy() {
    this.$eventBus.$off('showCadastreDetailsModal')
  }
}
</script>

<style scoped>

</style>
